// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cvMT","label":"styles_label__1-76_"};